module.exports = __webpack_public_path__ + "img/Shot02_Statue_Bladder_Highlighted.png";